import Axios from 'axios'
import {cateringLevyUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_catering_levies (context) {
    Axios.get(cateringLevyUrls.getAllCateringLevies).then(function (response) {
      context.commit('GET_ALL_CATERING_LEVIES', response.data)
    })
  },
  get_catering_levies (context, publicId) {
    Axios.get(cateringLevyUrls.getCateringLevies + publicId).then(function (response) {
      context.commit('GET_CATERING_LEVIES', response.data)
    })
  },
  get_deleted_catering_levies (context) {
    Axios.get(cateringLevyUrls.getDeletedCateringLevy).then(function (response) {
      context.commit('GET_DELETED_CATERING_LEVIES', response.data)
    })
  },
  get_catering_levy (context, publicId) {
    Axios.get(cateringLevyUrls.getCateringLevy + publicId).then(function (response) {
      context.commit('GET_CATERING_LEVY', response.data)
    })
  },
  get_current_catering_levy (context) {
    Axios.get(cateringLevyUrls.getCurrentCateringLevy).then(function (response) {
      context.commit('GET_CATERING_LEVY', response.data)
    })
  },
  post_catering_levy (context, data) {
    Axios.post(cateringLevyUrls.postCateringLevy, data).then(function () {
      context.dispatch('get_all_catering_levies')
      router.push({
        name: 'CateringLevyHistory'
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  update_catering_levy (context, data) {
    Axios.post(cateringLevyUrls.editCateringLevy, data).then(function () {
      context.dispatch('get_all_catering_levies')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_catering_levy (context, publicId) {
    Axios.delete(cateringLevyUrls.deleteCateringLevy + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_DELETED_CATERING_LEVIES', response.data)
      router.push({
        name: 'Module.DeletedCateringLevies'
      })
    })
  },
  restoreCateringLevy (context, publicId) {
    Axios.get(cateringLevyUrls.restoreCateringLevy + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_CATERING_LEVIES', response.data)
      router.push({
        name: 'Module.CateringLevies'
      })
    })
  }
}
